export function getCookie(name: string) {
  const cookies = document.cookie.split(';')
  for (const cookie of cookies) {
    const [cookieName, ...cookieValueParts] = cookie.split('=')
    const cookieNameTrim = cookieName.trim()
    if (cookieNameTrim === name) {
      return decodeURIComponent(cookieValueParts.join('='))
    }
  }
  return null
}

export function setCookie(
  name: string,
  value: string,
  days: number,
  secure: boolean = true
) {
  let expires = ''
  if (days) {
    const date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    expires = '; expires=' + date.toUTCString()
  }
  let cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/'
  if (secure) {
    cookie += '; Secure'
  }
  cookie += `; SameSite=Strict`
  document.cookie = cookie
}

export function deleteCookie(name: string) {
  document.cookie =
    name + '=; Max-Age=-99999999; path=/; Secure; SameSite=Strict'
}
